import script from "./EditChallan.vue?vue&type=script&setup=true&lang=js"
export * from "./EditChallan.vue?vue&type=script&setup=true&lang=js"

import "./EditChallan.vue?vue&type=style&index=0&id=0bbc4640&lang=css"

const __exports__ = script;

export default __exports__